import React from 'react';
import FeedbackTemplateApp from './components/FeedbackTemplateApp';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <FeedbackTemplateApp />
    </div>
  );
}

export default App;